import { render, staticRenderFns } from "./imagesPopup.vue?vue&type=template&id=1fd80c7c&scoped=true&"
import script from "./imagesPopup.vue?vue&type=script&lang=js&"
export * from "./imagesPopup.vue?vue&type=script&lang=js&"
import style0 from "./imagesPopup.vue?vue&type=style&index=0&id=1fd80c7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd80c7c",
  null
  
)

export default component.exports